export default {
  defaultObject () {
    return {
      id: undefined,
      name: ''
    }
  }
}